import React from 'react';
import YearPillsRow from '../YearPillsRow';
import HeaderControls from './header-controls';

const PageHeader = ({
  year,
  setYear,
  sortDescending,
  toggleSort,
  darkMode,
  toggleDarkMode,
  isMosaicView,
  toggleView,
  showMarquee,
  toggleShowMarquee,
  isRealTime,
  toggleRealTime
}) => {
  return (
    // A fragment, not a wrapper: `position: sticky` is clipped by its parent's
    // box, so the sticky band has to be a direct child of the tall page
    // container to travel with the scroll.
    <>
      <div className="flex items-center gap-3 pb-4">
        <div className="w-12 h-12 nfl-gradient rounded-xl flex items-center justify-center shadow-lg border border-primary/20">
          <span className="text-2xl">🏈</span>
        </div>
        <div className="flex flex-col">
          <h1 className="text-3xl font-bold leading-tight text-foreground tracking-tight">Resultado Picks</h1>
          <span className="text-sm text-muted-foreground font-medium">Temporada {year}</span>
        </div>
      </div>

      {/* Controls and season pills stay reachable while the table scrolls; the
          title scrolls away. `-mx-4 px-4` lets the material span the
          container's gutters while the content keeps its original alignment. */}
      <div className="site-header sticky top-0 z-40 -mx-4 mb-4 px-4 py-2 border-b border-border bg-background/85 backdrop-blur-md supports-[backdrop-filter]:bg-background/70">
        <HeaderControls
          sortDescending={sortDescending}
          toggleSort={toggleSort}
          darkMode={darkMode}
          toggleDarkMode={toggleDarkMode}
          isMosaicView={isMosaicView}
          toggleView={toggleView}
          showMarquee={showMarquee}
          toggleShowMarquee={toggleShowMarquee}
          isRealTime={isRealTime}
          toggleRealTime={toggleRealTime}
        />

        <YearPillsRow setYear={setYear} year={year} />
      </div>
    </>
  );
};

export default PageHeader;
